// Symbol Card Component for desktop view
const SymbolCard = ({ symbol, selected, onSelect, disabled, isSubmitted = false }) => {
  const lockedSubmitted = Boolean(isSubmitted) && Boolean(selected);
  return (
    <div
      onClick={() => !disabled && !lockedSubmitted && onSelect(symbol)}
      className={`cursor-pointer border-2 rounded-lg p-4 flex items-center justify-between transition-all ${lockedSubmitted
        ? 'border-[#CCCCCC] bg-[#EEECEC] cursor-default text-[#666666]'
        : selected
          ? 'border-[#753ABF] bg-[#753ABF]/10 text-[#753ABF] cursor-default'
          : !disabled ? 'border-[#753ABF]/30 hover:border-[#753ABF]/50 text-[#753ABF]' : 'cursor-default opacity-50 bg-[#EEECEC] text-[#666666]'}`}
    >
      <div className="flex items-center">
        <img src={symbol.image} alt={symbol.label} className="w-12 h-12" />
        <p className={`pl-5 font-bold`}>{symbol.label}</p>
      </div>
      {selected && !lockedSubmitted && <img src="/Assets/Images/SymbolTick.svg" alt="selected" className="w-7 h-7 opacity-70" />}
      {selected && lockedSubmitted && <img src="/Assets/Images/DisabledSymbolTick.svg" alt="selected" className="w-7 h-7 opacity-70" />}
    </div>
  );
};

export default SymbolCard;